'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SessionStorageManager = exports.SessionStorageManager = undefined;

exports.SessionStorageManager = SessionStorageManager = function SessionStorageManager(refs) {
    var t = this;

    // constants
    t.db = 'dhis2';
    t.supported = 'sessionStorage' in window && window['sessionStorage'] !== null;

    // fn
    t.supportHandler = function () {
        if (!this.supported) {
            alert("Your browser is outdated and does not support local storage. Please upgrade your browser.");
            return;
        }

        return true;
    };
};

SessionStorageManager.prototype.get = function (session) {
    if (!this.supportHandler()) {
        return;
    }

    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};

    return db[session];
};

SessionStorageManager.prototype.set = function (layout, session, redirectUrl) {
    if (!this.supportHandler()) {
        return;
    }

    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};
    db[session] = layout;
    sessionStorage.setItem(this.db, JSON.stringify(db));

    if (redirectUrl) {
        window.location.href = redirectUrl;
    }
};
//# sourceMappingURL=SessionStorageManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/SessionStorageManager.js
 ** module id = 191
 ** module chunks = 0 1
 **/